import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Icon from '@material-ui/core/Icon';
import TextField from '@material-ui/core/TextField';
import ToggleButton from '../ToggleButton/ToggleButton';

// Optional: If you’re using react-intl for localization
import { FormattedMessage, injectIntl } from 'react-intl';

// Helper for updating fields
const updateField = (data, action, event) => {
  data[event.target.id] = event.target.value;
  data.modified = true;
  action(data);
};

const styles = theme => ({
  root: {
    flexGrow : 1,
    width    : '100%',
    margin   : 12,
    display  : 'inline-flex',
  },
  button: {
    margin   : theme.spacing.unit,
    fontSize : '24px',
  },
  textField: {
    margin   : theme.spacing.unit,
  },
  // Larger row style for active contexts
  rowActive: {
    minHeight: 200,
    border: '3px solid #3f51b5',
    borderRadius: 5,
  },
  // Larger text fields for active contexts
  textFieldActive: {
    margin   : theme.spacing.unit * 2,
    fontSize : '1.1rem',
  },
});

const AiContext = ({
  object,
  action,
  updateAction,
  deleteAction,
  classes,
  intl
}) => {
  // Decide row class based on active
  const rowClass = object.active ? `${classes.root} ${classes.rowActive}` : classes.root;
  
  // Decide text field class based on active
  const getTextFieldClass = () => object.active ? `${classes.textField} ${classes.textFieldActive}` : classes.textField;
  // Increase the default rows if active
  const getRows = () => (object.active ? 4 : 2);

  return (
    <TableRow>
      <TableCell className={rowClass}>
        {/* Preamble */}
        <TextField
          id="preamble"
          label="Preamble"
          value={object.preamble || ''}
          onChange={e => updateField(object, action, e)}
          multiline
          rows={getRows()}
          className={getTextFieldClass()}
          margin="dense"
          fullWidth
        />
        {/* General Rules */}
        <TextField
          id="general_rules"
          label="General Rules"
          value={object.general_rules || ''}
          onChange={e => updateField(object, action, e)}
          multiline
          rows={getRows()}
          className={getTextFieldClass()}
          margin="dense"
          fullWidth
        />
        {/* RAG Rules */}
        <TextField
          id="rag_rules"
          label="RAG Rules"
          value={object.rag_rules || ''}
          onChange={e => updateField(object, action, e)}
          multiline
          rows={getRows()}
          className={getTextFieldClass()}
          margin="dense"
          fullWidth
        />

        {/* Active Toggle */}
        <ToggleButton
          id="active"
          label="Active"
          checked={object.active}
          onChange={() => {
            const data = { ...object, active: !object.active, modified: true };
            action(data);
          }}
        />
      </TableCell>

      {/* Actions Cell */}
      <TableCell>
        {/* Save Button */}
        <IconButton
          color="primary"
          className={classes.button}
          aria-label="Save"
          disabled={!object.modified}
          onClick={() => {
            updateAction(object);
          }}
        >
          <Icon>save</Icon>
        </IconButton>

        {/* Delete Button */}
        <IconButton className={classes.button} aria-label="Delete">
          <DeleteIcon
            onClick={() => {
              deleteAction(object);
            }}
          />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

AiContext.propTypes = {
  object      : PropTypes.object.isRequired,
  action      : PropTypes.func.isRequired,
  updateAction: PropTypes.func.isRequired,
  deleteAction: PropTypes.func.isRequired,
  classes     : PropTypes.object.isRequired,
  intl        : PropTypes.object,
};

const AiContextWithStyles = withStyles(styles)(AiContext);

// If not using react-intl, export AiContextWithStyles
export default injectIntl(AiContextWithStyles);